import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { shareContent } from '../../../actions/spaces/ShareContentAction';
import { IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const ShareContentAction: IEntityAction<IContentInfo, {}> = {
  name: 'shareContent',
  translateName: Messages.share_content_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return FeatureFlags.newShareDialogEnabled && !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: () => true,
  createReduxAction: (targetItems: IContentInfo[]) => {
    return shareContent(targetItems[0]);
  }
};
